import cn from 'classnames';

export interface TipProps {
  text: string;
  /** @default 'success' */
  color?: 'success' | 'error' | 'warning' | 'info';
  className?: string;
}

const Tip = ({ text, color = 'success', className }: TipProps) => {
  return (
    <div className={cn('tip', color, className)}>
      <span className='tip__text'>{text}</span>
    </div>
  );
};

export default Tip;
